import React from "react";
import ReactDOM from "react-dom";

import { useSelector } from "react-redux";

// Components
import NotificationItem from "./item";

const Notifications = () => {
  const notifications = useSelector(
    (state) => state.notification.notifications
  );

  if (typeof document === "undefined") {
    return null;
  }

  return (
    <div className="notification-container">
      {notifications.slice(0, 3).map((not) => (
        <NotificationItem notification={not} key={not.id} />
      ))}
    </div>
  );
};

export default Notifications;
